import PropTypes from "prop-types";
import { ComponentSpinner } from "@components/spinner";
import useBrandKyc from "./hooks/use-brand-kyc";
import KycDocumentsCard from "./components/kyc-documents-card";
import KycStatusCard from "./components/kyc-status-card";

const BrandKyc = ({ brandId }) => {
    const {
        loading,
        saving,
        documents,
        timeline,
        status,
        statusDraft,
        setStatusDraft,
        canUpdateStatus,
        isStatusDirty,
        statusNote,
        applyStatus,
        attachDocuments,
        deleteDocument,
        isDeleting
    } = useBrandKyc(brandId);

    if (loading) {
        return (
            <div className="flex justify-center py-16">
                <ComponentSpinner />
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-3">
            <div className="lg:col-span-2">
                <KycDocumentsCard
                    documents={documents}
                    onUploaded={attachDocuments}
                    onDelete={deleteDocument}
                    isDeleting={isDeleting} />
            </div>

            <KycStatusCard
                status={status}
                statusDraft={statusDraft}
                canUpdateStatus={canUpdateStatus}
                isStatusDirty={isStatusDirty}
                statusNote={statusNote}
                saving={saving}
                timeline={timeline}
                onStatusDraftChange={setStatusDraft}
                onApplyStatus={applyStatus} />
        </div>
    );
};

BrandKyc.propTypes = {
    brandId: PropTypes.string.isRequired
};

export default BrandKyc;
